/* eslint-disable react/no-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

class NumberInput extends Component {
  constructor(props) {
    super(props);
    this.decrement = this.decrement.bind(this);
    this.increment = this.increment.bind(this);
    this.onChange = this.onChange.bind(this);
    this.timer = null;
    this.delay = 300;
    this.state = {
      value: props.value,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      value: nextProps.value,
    });
  }

  decrement() {
    if (this.state.value - this.props.step >= this.props.min) {
      this.setState({
        value: this.state.value - this.props.step,
      });
      clearTimeout(this.timer);
      this.timer = setTimeout(
        () =>
          this.props.onChange(this.props.name,
            this.state.value),
        this.delay
      );
    }
  }

  increment() {
    if (this.state.value + this.props.step <= this.props.max) {
      this.setState({
        value: this.state.value + this.props.step,
      });
      clearTimeout(this.timer);
      this.timer = setTimeout(
        () =>
          this.props.onChange(this.props.name,
            this.state.value),
        this.delay
      );
    }
  }

  onChange(event) {
    let value = parseInt(event.target.value,
      10) || 0;
    if (value > this.props.max) {
      value = this.props.max;
    }
    if (value < this.props.min) {
      value = this.props.min;
    }
    if (value !== this.props.value) {
      this.setState({
        value,
      });
      clearTimeout(this.timer);
      this.timer = setTimeout(
        () =>
          this.props.onChange(this.props.name,
            this.state.value),
        this.delay
      );
    }
  }

  render() {
    let decrementClassName = 'counter__decrement';
    let incrementClassName = 'counter__increment';

    if (this.props.value === this.props.min) {
      decrementClassName += ' counter__decrement--disabled';
    }

    if (this.props.value === this.props.max) {
      incrementClassName += ' counter__increment--disabled';
    }

    return (
      <div className="counter">

        <div
          className={decrementClassName}
          onClick={this.decrement}
        >
          <i />
        </div>

        <input
          className="counter__input"
          max={this.props.max}
          min={this.props.min}
          onChange={this.onChange}
          step={this.props.step}
          type="number"
          value={this.state.value}
        />

        <div
          className={incrementClassName}
          onClick={this.increment}
        >
          <i />
        </div>

      </div>
    );
  }
}

NumberInput.PropTypes = {
  max:PropTypes.number,
  min:PropTypes.number,
  name:PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  step:PropTypes.number,
  value:PropTypes.number.isRequired,
};

NumberInput.defaultProps = {
  max: Number.MAX_SAFE_INTEGER,
  // For reality of current project only.
  min: 0,
  step: 1,
};

export default NumberInput;
